import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const StyledMostPopularContainerWrapper = styled(FlexColumn)`
    justify-content: center;
    max-width: 1368px;
`;

export const StyledMostPopularHeader = styled(FlexRow)`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])}
    line-height: 24px;
    margin-bottom: 24px;
`;

export const StyledMostPopularContainer = styled(FlexRow)`
    flex-wrap: wrap;
    gap: 24px;
`;
